import { Pipe, PipeTransform } from '@angular/core';
import { Code } from '@app/modules/smart-devices/data/smart-devices.interface';

@Pipe({
  standalone: false,
  name: 'codeFirstUsedAt',
})
export class CodeFirstUsedAtPipe implements PipeTransform {
  transform(codes: Code[]): string | null {
    if (!codes || codes.length === 0) {
      return null;
    }

    const firstUsedAt = codes
      .map((code) => code.first_used_at)
      .sort()
      .shift();

    return firstUsedAt;
  }
}
